import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable()
export class SnackbarService {

  constructor(private snackBar: MatSnackBar) {}
  public openSnackBar(message: string, action: string, snackType?: string) {
    const _snackType: string =
      snackType !== undefined ? snackType : 'Success';

    this.snackBar.openFromComponent(SnackbarComponent, {
      duration: 10000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      data: { message: message, snackType: _snackType },
      panelClass: ['msg-snackbar-' + snackType.toLocaleLowerCase()]
    });
  }
}
